import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from "../ErrorBoundary";
import "./Page.css";
const baseClassName = "page";
const Page = ({ children, className }) => (_jsx(ErrorBoundary, { children: _jsx("main", Object.assign({ className: className ? `${baseClassName} ${className}` : baseClassName }, { children: children })) }));
export default Page;
